import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SortableComponent } from './sortable.component';
import { DraggableItemService } from './draggable-item.service';


export class SortableModule {
  static forRoot(): ModuleWithProviders {
    return { ngModule: SortableModule, providers: [DraggableItemService] };
  }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [SortableComponent],
  imports: [CommonModule],
  exports: [SortableComponent]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}



// WEBPACK FOOTER //
// ../../.tmp/sortable/sortable.module.ts